var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBell = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 2.383c-2.026 0-3.667.786-4.782 2.228-1.096 1.418-1.632 3.4-1.632 5.722v.75c0 2.48-.999 4.418-2.078 5.54a.98.98 0 0 0-.205 1.038.96.96 0 0 0 .895.622h15.606c.459 0 .774-.307.895-.622a.98.98 0 0 0-.205-1.038c-1.08-1.122-2.078-3.06-2.078-5.54v-.75c0-2.322-.536-4.304-1.633-5.722-1.115-1.442-2.755-2.228-4.782-2.228m-5.014 7.95c0-2.129.494-3.772 1.34-4.866.828-1.07 2.044-1.684 3.675-1.684s2.847.614 3.675 1.684c.846 1.094 1.34 2.737 1.34 4.866v.75c0 2.41.817 4.41 1.865 5.8H5.121c1.048-1.39 1.865-3.39 1.865-5.8z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.286 19.617a.7.7 0 0 0-1.043.933A3.7 3.7 0 0 0 12 21.783a3.7 3.7 0 0 0 2.757-1.233.7.7 0 1 0-1.043-.934 2.3 2.3 0 0 1-1.714.767 2.3 2.3 0 0 1-1.715-.767"
})));
export default SvgBell;